import React from 'react';
import { ClockIcon, FileTextIcon, MailOpenIcon } from 'lucide-react';
import { NewsletterForm } from './NewsletterForm';
const points = [{
  icon: MailOpenIcon,
  title: 'Nye lån, så snart de åbner',
  text: 'Du får mailen samme dag, lånet lægges på primærmarkedet – før andelene er fordelt.'
}, {
  icon: FileTextIcon,
  title: 'Hele investeringscasen',
  text: 'Rente, løbetid, formål, rating, risiko og sikkerhed står i mailen, så du kan beslutte hurtigt.'
}, {
  icon: ClockIcon,
  title: 'Cirka én mail pr. nyt lån',
  text: 'Ingen nyhedsstrøm. Kun besked når der faktisk er noget at investere i. Afmeld når som helst.'
}];
export function NewsletterSection() {
  return <section id="nyhedsbrev" aria-labelledby="nyhedsbrev-title" className="scroll-mt-24 border-t border-ink/10 py-16 lg:py-24" data-id="element-104" data-mp="3qpei9gnu2xtz">
      <div className="grid gap-6 lg:grid-cols-12" data-id="element-105" data-mp="32yijfzkyn2d8">
        <div className="rounded-4xl bg-forest p-8 text-white lg:col-span-7 lg:p-12" data-id="element-106" data-mp="2y0qp6ywuf45v">
          <p className="text-sm font-semibold uppercase tracking-[0.14em] text-lime" data-id="element-107" data-mp="38mqvqc9jq3q9">
            Vigtigst af alt
          </p>
          <h2 id="nyhedsbrev-title" className="mt-4 max-w-xl text-3xl font-bold leading-tight tracking-tight lg:text-[2.75rem]" data-id="element-108" data-mp="3djhcl1t6d3cq">
            Mailen er den eneste måde at nå de nye lån først
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-109" data-mp="2pn38nxvh65pu">
            Lån annonceres ikke på forhånd, og de mest attraktive bliver
            fuldtegnet hurtigt. Tilmeld dig, og få besked direkte i din inbox,
            når et nyt lån åbner.
          </p>

          <div className="mt-9 max-w-xl" data-id="element-110" data-mp="2zndlvihifd50">
            <NewsletterForm tone="dark" id="nyhedsbrev-email" data-id="element-111" data-mp="33n4ja51jkrii" />
            <p className="mt-4 text-sm text-white/50" data-id="element-112" data-mp="33kjfvblli3in">
              Du kan afmelde med ét klik. Vi deler ikke din mail.
            </p>
          </div>

          <ul className="mt-10 grid gap-6 border-t border-white/10 pt-9 sm:grid-cols-3" data-id="element-113" data-mp="ivlti0j6zzc0">
            {points.map(point => <li key={point.title} data-id="element-114" data-mp="2fvgfy00i61rf">
                <point.icon className="h-5 w-5 text-lime" aria-hidden="true" data-id="element-115" data-mp="2aygfc4mf9r7p" />
                <p className="mt-3 font-bold leading-snug" data-id="element-116" data-mp="2owoac6zweig8">{point.title}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-117" data-mp="2jyd3840zmm1p">
                  {point.text}
                </p>
              </li>)}
          </ul>
        </div>

        <figure className="flex flex-col rounded-4xl bg-white p-6 ring-1 ring-ink/10 lg:col-span-5 lg:p-8" data-id="element-118" data-mp="1s7yu0l3x5xwd">
          <figcaption className="text-sm font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-119" data-mp="25zn4yl2fmgbr">
            Sådan ser mailen ud
          </figcaption>
          <p className="mt-3 text-base leading-relaxed text-ink" data-id="element-120" data-mp="2172d3p336dav">
            Ét lån pr. mail, med rente, løbetid, formål og sikkerhed – og et
            direkte link til at investere.
          </p>
          <div className="mt-6 flex-1 overflow-hidden rounded-2xl bg-canvas ring-1 ring-ink/10" data-id="element-121" data-mp="18jfzdo059saa">
            <img src="https://cdn.magicpatterns.com/uploads/kT8u3fa1JQ3VYXoZUxGHnQ/Screenshot_2026-09-10_at_12.54.46.png" alt="Eksempel på investormail fra Flex Funding om et lån til Nordsjællands whiskydestilleri med rente, løbetid og sikkerhed." loading="lazy" className="block w-full" data-id="element-122" data-mp="3k5rwkhsq45pj" />
          </div>
        </figure>
      </div>
    </section>;
}